import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { GetMyLicensesService, GetAutodeskLetter } from "../../services/ProfileService";
import Str from "../common/Str";
import SkeletonTicketList from "../../loaders/SkeletonTicketList";
import moment from 'moment';
import { BASE_URL, UPLOAD_ROOT_PATH } from '../../utils/Constants';
import Swal from "sweetalert2";

const Licenses = (props) => {
  const [licenses, setLicenses] = useState([]);
  const [search, setSearch] = useState("");
  const [renderTable, setRenderTable] = useState(true);
  const [loading, setLoading] = useState(false);
  const [canGetAutodesk, setCanGetAutodesk] = useState(false);
  const [refresh, setRefresh] = useState(false);
  useEffect(() => {
    setRenderTable(false);
    GetMyLicensesService()
      .then((res) => {
        setLicenses(res.data.licenses_data);
        setCanGetAutodesk(res.data?.canGetAutodesk ? true : false);
      })
      .catch(err=>{
        console.log(err)
      }).finally(()=>{
        setRenderTable(true);
      });
  }, []);
  useEffect(() => {
    setRenderTable(false);
    GetMyLicensesService()
      .then((res) => {
        setLicenses(res.data.licenses_data);
        setCanGetAutodesk(res.data?.canGetAutodesk ? true : false);
      })
      .catch(err=>{
        console.log(err)
      }).finally(()=>{
        setRenderTable(true);
      });
  }, [refresh]);
  const handleRequestAutodesk = () =>{
          setLoading(true)
          GetAutodeskLetter().then((res)=>{
              if(res.status === 200){
                  // const fileURL = BASE_URL +  (res.data.url).replace(UPLOAD_ROOT_PATH,"").replace("public", "");
                  // window.open(fileURL, "_blank");
                  setRefresh(!refresh)
              }
          }).catch((err)=>{            
              Swal.fire({
                  icon: "error",
                  title: "Could not generate Autodesk Eligibility Letter",
                  text: err.response.data.message,
              });
          }).finally(() =>{
              setLoading(false);
          })
      }
  const columns = [
    {
      name: "Name",
      selector: "file_name",
      sortable: true,
    },
    {
      name: "Date Generated",
      selector: "date_generated",
      sortable: true,
      cell: (row) =>(row?.date_generated ? moment.unix(row?.date_generated).format("DD MMM YYYY hh:mm a") : "-")
    },
    {
      name: "Action",
      selector: "action",
      cell: (row) => (
                      <div className="assessment-08 advSearch-action-con">
                          <div className="as-buttons">
                              <a
                                  href={BASE_URL +  (row?.path).replace(UPLOAD_ROOT_PATH,"").replace("public", "")}
                                  target="_blank"
                                  className="btn btn-primary rounded-circle view-btn"
                                  title="Download"
                              >
                                  <i className="fal fa-download"></i>
                              </a>
                          </div>
                      </div>
                  ),
    }
  ];
  
  const resetFilter = () => {
    setSearch("")
  }

  const handleSearchFilter = (e) => {
    setSearch(e.target.value);
  }

  const dataToRender = () =>{
    let updatedData = [];
    let data = [...licenses];

    if(search.length){
      let tempName = data.filter(item =>{
        let includes = item?.license_type.toLowerCase().includes(search.toLowerCase());
        if(includes){
          return includes
        }else{
          return null;
        }
      })
      let tempOriginName = data.filter(item =>{
        let includes = item?.userPrincipalName.toLowerCase().includes(search.toLowerCase());
        if(includes){
          return includes
        }else{
          return null;
        }
      })

      const finalData = [...tempName, ...tempOriginName];

      let unique = [...new Set(finalData)];

      updatedData = unique;      
    }else{
      updatedData = data;
    }

    return updatedData;
  }

  return (
    <div className="custom-table-div filter-search-icon card card-table-custom">
      <div className="search-filter-div">
        <div className="search-filter-div-left">
            <div className="system-administration-table table-responsive">
                <div className="table-responsive-div">
                    <div id="assessment-table-main_wrapper" className="dataTables_wrapper no-footer">
                        <div id="assessment-table-main_filter" className="dataTables_filter">
                            <label for="filterDataTable" className="icon"></label>
                            <input
                                type="text"
                                name="filterDataTable"
                                className="filter-text"
                                placeholder="Search"
                                onChange={handleSearchFilter}
                                value={search}
                            />
                            <div className="filter-eff filter-data-btn">
                                <button className="filter-buttons">
                                    <i className="fal fa-filter"></i>
                                </button>
                            </div> 
                        </div>
                    </div>
                </div>
                <div className="filter-button-group">
                    <div className="reset-btn-group">
                        <div className="button-reset">
                            <button className="btn btn-primary" onClick={resetFilter} title="Reset">
                                <i className="fal fa-redo"></i>Reset
                            </button>
                        </div>
                    </div>
                </div>   
                            
            </div>
        </div>
        <div className="search-filter-div-right">
          <div className="filter-search-bar-blk">
            <div className="add-ticket-blk button-reset">
              {canGetAutodesk ? (
              <button disabled={loading} className="btn btn-primary" title="Request Autodesk Eligibility Letter" onClick={() => {handleRequestAutodesk(); }}>
                {loading ? <i className="fas fa-cog fa-spin"></i> : <i className="fal fa-file-invoice"></i>} Request Autodesk Eligibility Letter
              </button>
              ) : ''}
            </div>
          </div>
        </div>             
      </div>                
      <DataTable
        columns={columns}
        data={dataToRender()}
        progressPending={!renderTable}
        pagination={true}
        defaultSortField="license_type"
        defaultSortAsc={false}
        highlightOnHover={false}
        progressComponent={<SkeletonTicketList />}
        noDataComponent={Str.noRecord}
      />
    </div>  
  );
};

export default Licenses;
